<template>
  <element>
    <AppBar :title="$t('carsPage.title')" />
    <v-container>
      <v-row no-gutters>
        <v-col>
          <LabelTextField :label="$t('carsPage.filterLabel')" @change="onFilterChange" />
        </v-col>
      </v-row>
     
      <v-row no-gutters class="card-list">
        <CarInfoCard
          v-for="car in filtered"
          :key="car.car_id"
          :carId="car.car_id"
          :licensePlateNumber="car.license_plate_number"
          :vin="car.vin"
        >
        </CarInfoCard>
      </v-row>
       <v-progress-circular
        v-if="isLoading"
        class="mt-3"
        :size="70"
        :width="7"
        color="#033e8c"
        indeterminate
      ></v-progress-circular>
      <v-btn
      @click="loadMore"
      v-show="!isLoading"
      >Load more</v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import LabelTextField from "@/components/common/LabelTextField.vue";
import CarInfoCard from "@/components/car/CarInfoCard.vue";

export default {
  name: "CarsPage",
  components: {
    AppBar,
    LabelTextField,
    CarInfoCard,
  },
  data() {
    return {
      isLoading: false,
      filterString: '',
      // cars: [],
      filtered: [],
      records_per_page: 10,
      page:1,
    }
  },
  computed: {
    cars: function () {
      return this.$store.getters.getCars
    }
  },
  methods: {
    onFilterChange(value) {
      if (value != this.filterString) {
        this.filterString = value
        this.filter()
      }
    },
    filter() {
      if (this.cars.length == 0)
        return

      if (this.filterString.length == 0)
      {
        this.filtered = this.cars
        return 
      }

      this.isLoading = true
      this.filtered = []
      const filter = this.filterString.toLowerCase()

      this.filtered = this.cars.filter(car => car.vin?.toLowerCase().includes(filter)
          || car.license_plate_number?.toLowerCase().includes(filter)
          || car.status?.toLowerCase().includes(filter))

      this.isLoading = false
    },
    loadMore(){
      console.log('Load more...');
      this.page = this.page + 1;
      this.isLoading = true
      this.$store.dispatch('retrieveCars' , {page: this.page, records_per_page: this.records_per_page} )
      // eslint-disable-next-line no-unused-vars
        .then(response => {
          console.log("Successfully retrieved cars")
          this.filtered = this.cars
        })
        .catch((error) => {
          console.log("Failed retrieving cars", error)
        })
        .finally(() => (this.isLoading = false));
    }
  },
  created() {
    this.isLoading = true
    this.$store.dispatch('retrieveCars' , {page: this.page, records_per_page: this.records_per_page} )
    // eslint-disable-next-line no-unused-vars
      .then(response => {
        console.log("Successfully retrieved cars")
        this.filtered = this.cars
      })
      .catch((error) => {
        console.log("Failed retrieving cars", error)
      })
      .finally(() => (this.isLoading = false));
  }
}
</script>

<style scoped>
.card-list {
  padding-top: 1.1875rem;
}

@media only screen and (max-width: 376px) {
  .page-root {
    width: 330px;
    padding: 0;
    margin-top: 0.625rem;
  }
}
</style>
